import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import heroBg from '../../assets/1.jpg'; // Hero section image import

// Dynamically load gold images (001 - 013)
const goldImages = Array.from({ length: 13 }, (_, i) => {
  const num = String(i + 1).padStart(3, '0');
  try {
    return { src: require(`../../assets/wvt-g-${num}.jpg`), name: `WVT-G-${num}` };
  } catch (err) { return null; }
}).filter(Boolean);

// Dynamically load rose gold images (001 - 023)
const roseGoldImages = Array.from({ length: 23 }, (_, i) => {
  const num = String(i + 1).padStart(3, '0');
  try { return { src: require(`../../assets/wvt-rg-${num}.jpg`), name: `WVT-RG-${num}` }; } 
  catch (err) { return null; }
}).filter(Boolean);

// Dynamically load silver images (001 - 015)
const silverImages = Array.from({ length: 15 }, (_, i) => {
  const num = String(i + 1).padStart(3, '0');
  try { return { src: require(`../../assets/wvt-s-${num}.jpg`), name: `WVT-S-${num}` }; } 
  catch (err) { return null; }
}).filter(Boolean);

const CabinDesign = () => {
  const [activeTab, setActiveTab] = useState('gold');

  const images = { gold: goldImages, roseGold: roseGoldImages, silver: silverImages };

  return (
    <div className="w-full">
      {/* Hero Section */}
      <div
        className="w-full h-[400px] md:h-[450px] bg-cover bg-center flex flex-col justify-center px-6"
        style={{ backgroundImage: `url(${heroBg})` }}
      >
        <h1 className="text-white text-4xl md:text-5xl font-bold">Cabin Design</h1>
        <div className="text-white mt-2 text-lg">
          <Link to="/" className="underline hover:text-gray-200">Home</Link> / Cabin Design
        </div>
      </div>

      {/* Tabs */}
      <div className="max-w-7xl mx-auto py-10 px-4">
 <div className="flex justify-center items-center mb-6 border-t border-gray-300 pt-2">
  {['gold', 'roseGold', 'silver'].map((tab, index, arr) => {
    let tabColor = '';
    if (tab === 'gold') tabColor = 'text-yellow-500';
    else if (tab === 'roseGold') tabColor = 'text-pink-500';
    else if (tab === 'silver') tabColor = 'text-gray-400';

    return (
      <button
        key={tab}
        onClick={() => setActiveTab(tab)}
        className={`pb-2 px-6 text-lg font-semibold uppercase ${tabColor} ${
          activeTab === tab ? 'border-b-2 border-orange-500' : ''
        } ${index !== arr.length - 1 ? 'border-r border-gray-300' : ''}`}
      >
        {tab.replace(/([A-Z])/g, ' $1').toUpperCase()}
      </button>
    );
  })}
</div>



        {/* Image Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 justify-items-center">
          {images[activeTab].map((imgObj, idx) => (
            <div
              key={idx}
              className="overflow-hidden rounded-lg shadow-lg flex flex-col items-center"
            >
              <div className="w-full">
                <img
                  src={imgObj.src}
                  alt={imgObj.name}
                  className="w-full h-auto transform transition duration-300 hover:scale-105"
                />
              </div>
              <div className="mt-2 text-center font-medium">{imgObj.name}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CabinDesign;
